import styled from '@emotion/styled/macro';

import Button from '../../UI/Button/Button';

export const StyledButton = styled(Button)`
  margin-top: 1.25rem;
`;
